import { createRouter, createWebHistory } from 'vue-router';
import stores from '@ganaderia/stores';
import sharedStores from '@shared/shared-stores';

const NOT_PROTECTED_ROUTES = [
  'registrate',
  'login',
  'landingPage',
  'verifyRegistration',
  'resetPassword',
  'privacy',
  'licence',
  'contact',
  'termsAndConditions'
];

const router = createRouter({
  history: createWebHistory((import.meta as any).env.BASE_URL),
  routes: [
    { path: '/', name: 'landingPage', component: () => import('@ganaderia/views/Landing.vue') },
    { path: '/home', name: 'home', component: () => import('@ganaderia/views/Home.vue') },
    { path: '/login', name: 'login', component: () => import('@ganaderia/views/Login.vue') },
    { path: '/registrate', name: 'registrate', component: () => import('@ganaderia/views/Register.vue') },
    {
      path: '/verify-registration/:token',
      name: 'verifyRegistration',
      component: () => import('@ganaderia/views/VerifyRegistration.vue')
    },
    {
      path: '/reset-password/:token',
      name: 'resetPassword',
      component: () => import('@ganaderia/views/ResetPassword.vue')
    },
    { path: '/contact', name: 'contact', component: () => import('@ganaderia/views/Contact.vue') },
    { path: '/licence', name: 'licence', component: () => import('@ganaderia/views/Licence.vue') },
    { path: '/privacy', name: 'privacy', component: () => import('@ganaderia/views/Privacy.vue') },
    {
      path: '/terms-and-conditions',
      name: 'termsAndConditions',
      component: () => import('@ganaderia/views/Terms.vue')
    },
    { path: '/cows', name: 'cows', component: () => import('@ganaderia/views/CowList.vue') },
    { path: '/cows-dead', name: 'cows-dead', component: () => import('@ganaderia/views/CowList.vue') },
    { path: '/cows-sold', name: 'cows-sold', component: () => import('@ganaderia/views/CowList.vue') },
    { path: '/cows/:id', name: 'cow-details', component: () => import('@ganaderia/views/CowDetails.vue') },
    { path: '/history', name: 'history', component: () => import('@ganaderia/views/History.vue') },
    { path: '/revisions', name: 'revisions', component: () => import('@ganaderia/views/Revisions.vue') },
    {
      path: '/revisions/:farmId/:date',
      name: 'revisions-detail',
      component: () => import('@ganaderia/views/RevisionsDetail.vue')
    },
    { path: '/milk', name: 'milk', component: () => import('@ganaderia/views/Milk.vue') },
    { path: '/backups', name: 'backups', component: () => import('@ganaderia/views/Backups.vue') },
    { path: '/upload', name: 'upload', component: () => import('@ganaderia/views/Upload.vue') },
    { path: '/syncs', name: 'syncs', component: () => import('@ganaderia/views/Syncs.vue') },
    { path: '/statistics', name: 'statistics', component: () => import('@ganaderia/views/Statistics.vue') },
    { path: '/agent', name: 'agent', component: () => import('@ganaderia/views/Agent.vue') },
    { path: '/settings', name: 'settings', component: () => import('@ganaderia/views/Settings.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
});

router.beforeEach(async (to, from) => {
  const alreadyLoggedIn = !!stores.auth.state.user.value;
  const isProtected = to.name !== 'landingPage' && !NOT_PROTECTED_ROUTES.includes(to.name as string);
  if (alreadyLoggedIn || (!isProtected && to.name !== 'landingPage') || from.name === 'login') {
    return true;
  }

  try {
    await stores.auth.funcs.ensureUser();
  } catch (error: any) {
    if (error?.response?.status === 401) {
      stores.auth.state.redirectToFromGuard.value = to.fullPath;
      return to.name === 'landingPage' ? true : { name: 'login' };
    }
    sharedStores.snackbar.funcs.notify({ text: `Error loading user: ${error}` });
    return { name: 'login' };
  }

  if (stores.auth.state.account.value!.farms.length > 0) {
    stores.app.state.selectedFarmId.value = stores.auth.state.account.value!.farms[0].id!;
  }
  return to.name === 'landingPage' ? { name: 'home' } : true;
});

export default router;
